// @erp/module-cms/schemas — the CMS grant matrix. Browser-safe: types + plain
// data only (fe/useCan and the gateway's rbac() evaluate the SAME map through
// can(), so UI affordance and server enforcement can never disagree).
//
// CAPABILITY FAMILY (L0 seed — extensible; scoped-role assignments and the
// read-split capabilities land with the routes that enforce them). Scope per the
// 2026-08-19 product decision: the CMS is the DYNAMIC-CONTENT backend for a
// STATIC Astro site — it owns content FEEDS, NOT the site's pages or navigation
// (those are hand-authored in apps/website for speed). So there is deliberately
// NO cms:pages and NO cms:menus family:
//   cms:announcements — notice / announcement CRUD (the companion-sync target)
//   cms:publications  — prospectus / book / syllabus / document CRUD
//   cms:events        — event CRUD (calendar entries, tickets, schedule)
//   cms:tenders       — tender / procurement CRUD (ref-no engine, corrigendums)
//   cms:gallery       — photo-gallery items (R2-backed, format overrides)
//   cms:newsletter    — subscriber capture + ESP sync
//   cms:media         — media library (R2 presign-backed assets)
//   cms:categories    — per-type taxonomy
//   cms:settings      — site-wide CMS settings (branding, ref-no seqs, defaults)
//   cms:iam           — CMS role/permission administration
//   cms:publish       — HIGH-IMPACT: promotes draft → live (public visibility). A
//                       candidate { sensitive: true } route (the ADR-000 §9.3
//                       hard-revoke gate) when the publish endpoint lands — NOT
//                       wired here (L0 seeds the grant vocabulary only, never
//                       route sensitivity).
//
// Read-scoped capabilities will be their own exact strings ('cms:pages.read'
// never falls out of 'cms:pages' — patterns are exact unless ':*'), mirroring
// the LIB '<family>.read' convention when the read/write split is drawn.
//
// Merge law: compose with the core seed via mergeGrants(ROLE_GRANTS, CMS_GRANTS)
// — NEVER an object spread, which would replace owner/admin's ['core:*'] with
// ['cms:*'] instead of granting both (the LIB precedent, auth-kit/rbac).
import type { RoleGrants } from "@erp/auth-kit/rbac";

export const CMS_GRANTS: RoleGrants = {
  owner: ["cms:*"],
  admin: ["cms:*"],
};
